import type { ThemeSettings } from '../runtime/services/CmsSettingsService';

export default defineNuxtPlugin({
    name: 'cms',
    dependsOn: ['axios'],
    async setup(nuxtApp)
    {
        const store = useComponentsStore();
        const { vueApp, $config } = useNuxtApp();
        const layers = $config.public.layerPaths.toReversed();

        // Module settings
        const requireModuleComponent = import.meta.glob('./**/_partials/module/*Settings.vue', { base: '../../../../' });

        for (const layer of layers)
        {
            Object.entries(requireModuleComponent).filter(([path]) => path.startsWith(`${layer}/app/`)).forEach(([path, component]: [string, any]) =>
            {
                const name = `CmsModule${path.split('/').last().replace('.vue', '')}`;

                if (!store.modules.includes(name))
                {
                    store.modules.push(name);
                    vueApp.component(name, defineAsyncComponent(component));
                }
            });
        }

        // Widget settings
        const requireWidgetComponent = import.meta.glob('./**/app/components/widget/**/*Settings.vue', { base: '../../../../' });

        for (const layer of layers)
        {
            Object.entries(requireWidgetComponent).filter(([path]) => path.startsWith(`${layer}/app/`)).forEach(([path, component]: [string, any]) =>
            {
                const name = `CmsWidget${path.split('/').last().replace('.vue', '')}`;

                if (!store.widgets.includes(name))
                {
                    store.widgets.push(name);
                    vueApp.component(name, defineAsyncComponent(component));
                }
            });
        }

        return {
            provide: {
                theme: (name: string, throwError: boolean = false) =>
                {
                    return useSettingsStore().$theme(name, throwError);
                }
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $theme(name: string, throwError?: boolean): Promise<ThemeSettings>;
    }
}
